//import React from 'react';
import '../../App.css';
import {Badge, Form} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {Alert} from 'react-bootstrap';
import {Bodyheaderlogin} from '../bodyheaderlogin';
import {Link, useNavigate} from "react-router-dom";
import Axios from 'axios';
import React, {useEffect, useState} from 'react';

function Bodysignup(props) {
    const [profile, setProfile] = useState([]);
    const [casino, setCasino] = useState([]);
    const [user, setUser] = useState('');
    const [userType, setUserType] = useState('');
    const [pass, setPass] = useState('');
    const [repeatPass, setRepeatPass] = useState('');
    const [casinoType, setCasinoType] = useState('');
    const [rut, setRut] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellido, setApellido] = useState('');
    const [alertHead, setAlertHead] = useState('');
    const [alertBody, setAlertBody] = useState('');
    const [alertClass, setAlertClass] = useState('');
    const [alertActivate, setAlertActivate] = useState(false);

    let statuscall = ''
    const navigate = useNavigate();

    const profileList = profile.map(
        (item, i) => <option key={i} value={item.id}>{item.nombre}</option>
    );

    const casinoList = casino.map((item, i) =>
        <option key={i} value={item.id}>{item.nombre}</option>
    );

    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLPROFILE, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            //Solo muestra perfiles de apoderado y dateches
            setProfile(response.data.filter(item => item.id !== 2));
        }).catch(error => {
            return error
        });


        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setCasino(response.data);
        }).catch(error => {
            return error
        });
    }, []);

    const setRutF = (e) => {
        // Despejar Puntos
        let valor = e.target.value.replace('.', '');
        // Despejar Guión
        valor = valor.replace('-', '');

        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0, -1);
        let dv = valor.slice(-1).toUpperCase();

        // Formatear RUN
        setRut(cuerpo + '-' + dv)

        // Si no cumple con el mínimo ej. (n.nnn.nnn)
        /*if(cuerpo.length < 7) { rut.setCustomValidity("RUT Incompleto"); return false;}
        
        // Calcular Dígito Verificador
        suma = 0;
        multiplo = 2;
        
        // Para cada dígito del Cuerpo
        for(i=1;i<=cuerpo.length;i++) {
        
            // Obtener su Producto con el Múltiplo Correspondiente
            index = multiplo * valor.charAt(cuerpo.length - i);
            
            // Sumar al Contador General
            suma = suma + index;
            
            // Consolidar Múltiplo dentro del rango [2,7]
            if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }

        }
        
        // Calcular Dígito Verificador en base al Módulo 11
        dvEsperado = 11 - (suma % 11);
        
        // Casos Especiales (0 y K)
        dv = (dv == 'K')?10:dv;
        dv = (dv == 0)?11:dv;
        
        // Validar que el Cuerpo coincide con su Dígito Verificador
        if(dvEsperado != dv) { rut.setCustomValidity("RUT Inválido"); return false; }
        
        // Si todo sale bien, eliminar errores (decretar que es válido)
        rut.setCustomValidity('');        
        /*this.setState({userType: event.target.value});
        */
    }


    const setTypeUser = (e) => {
        /*this.setState({userType: event.target.value});*/
        setUserType(e.target.value)
    }

    const setTypeCasino = (e) => {
        /*this.setState({casinoType: event.target.value});*/
        setCasinoType(e.target.value)

    }

    const setPassword = (e) => {
        /*this.setState({pass: event.target.value});*/
        setPass(e.target.value)
    }

    const setRepeatPassword = (e) => {

        setRepeatPass(e.target.value)
    }

    const setUserF = (e) => {
        /*this.setState({user: event.target.value});*/
        setUser(e.target.value)
        props.setStateMailP(e.target.value);
    }

    const setNombreF = (e) => {
        /*this.setState({nombre: event.target.value});*/
        setNombre(e.target.value)
    }

    const setApellidoF = (e) => {
        /*this.setState({apellido: event.target.value});*/
        setApellido(e.target.value)
    }

    const showAlert = (head, body, alertClass) => {
        setAlertHead(head);
        setAlertBody(body);
        setAlertClass(alertClass)
        setAlertActivate(true);
        setTimeout(() => {
            setAlertActivate(false);
        }, 5000);
    };

    const register = async (e) => {
        if (!userType) {
            showAlert('Registro', 'Debe seleccionar un tipo de usuario', 'danger');
            return;
        }
        if (!casinoType) {
            showAlert('Registro', 'Debe seleccionar un casino', 'danger');
            return;
        }
        if (!user) {
            showAlert('Registro', 'Debe ingresar un correo electrónico', 'danger');
            return;
        }
        if (!pass) {
            showAlert('Registro', 'Debe ingresar una contraseña', 'danger');
            return;
        }
        if (!repeatPass) {
            showAlert('Registro', 'Debe ingresar nuevamente la contraseña', 'danger');
            return;
        }
        if (pass !== repeatPass) {
            showAlert('Registro', 'Las contraseñas no son iguales', 'danger');
            return;
        }
        if (!rut) {
            showAlert('Registro', 'Debe ingresar un rut', 'danger');
            return;
        }
        if (!nombre) {
            showAlert('Registro', 'Debe ingresar un nombre', 'danger');
            return;
        }
        if (!apellido) {
            showAlert('Registro', 'Debe ingresar un apellido', 'danger');
            return;
        }

        const data = {
            profile_id: userType,
            casino_id: casinoType,
            mail: user,
            password: pass,
            rut,
            nombre,
            apellido,
        };

        try {
            const response = await Axios.post(process.env.REACT_APP_URLREGISTER, data, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type',
                },
            });

            if (response.status === 200) {
                showAlert(
                    'Registro',
                    'Se ha enviado un código de autorización al mail con el que se ha registrado. Utilice este código para activar su cuenta en la pantalla a la cual será redirigido en unos segundos más. ¡No cierre esta pestaña de su navegador!. Muchas gracias.',
                    'success'
                );
                setTimeout(() => {
                    navigate('/Activate');
                    setAlertActivate(false);
                }, 20000);
            }
        } catch (error) {
            showAlert(error.response?.data?.MessageCode || 'Error', error.response?.data?.Message || 'Error al registrar', 'danger');
        }
    };

    return (
        <div className='justify-center w-full content-center items-center object-center flex my-4'>

            <div
                className='justify-center w-full content-center items-center object-center lg:max-w-lg flex max-w-sm flex-col gap-10'>
                <div className='flex-col w-full justify-center gap-2 flex'>
                    <div className='text-center'>
                        <h1>Registro</h1>
                    </div>
                    <Form.Select id='tipousuario' className='form-control input-lg' onChange={setTypeUser}
                                 aria-label="Default select example">
                        <option>Seleccione tipo de usuario</option>
                        {profileList}
                    </Form.Select>

                    <Form.Select className='form-control input-lg' onChange={setTypeCasino}
                                 aria-label="Default select example">
                        <option>Seleccione casino</option>
                        {casinoList}
                    </Form.Select>

                    <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" onChange={setNombreF}/>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control type="text" onChange={setApellidoF}/>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Rut</Form.Label>
                        <Form.Control type="text" value={rut} onChange={setRutF}
                                      placeholder="12123123-k">
                        </Form.Control>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Correo</Form.Label>
                        <Form.Control type="email" onChange={setUserF} placeholder="name@example.com"/>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control type="password" onChange={setPassword} placeholder="*************"/>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Repetir contraseña</Form.Label>
                        <Form.Control type="password" onChange={setRepeatPassword}
                                      placeholder="*************"/>
                    </Form.Group>



                    {alertActivate && (
                        <div className="mt-2">
                            <Alert variant={alertClass} onClose={() => setAlertActivate(false)} dismissible>
                            <Alert.Heading>{alertHead} {user}</Alert.Heading>
                            <p>
                                {alertBody}
                            </p>
                        </Alert>
                        </div>
                    )}

                    <div className="d-grid gap-2 w-full">
                        <Button variant="primary" size="lg" onClick={register}>
                            Registrar
                        </Button>
                    </div>
                </div>
                <div className="w-full text-center gap-2 flex flex-col">
                    <span>¿Ya estás registrado?</span>
                    <Link to={`/`} className="w-full">
                        <button
                            className="border-[#aa0047] border-1 w-full text-black hover:bg-[#aa0047] hover:bg-opacity-40 h-12 rounded-md text-lg"
                        >Ingresar
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );

}

export default Bodysignup